import React, { useState } from "react";
import { breaks } from "../../utils/Helpers";
import { breakIn } from "../../services";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


const BreakModal = ({ isOpen, onClose, fetchCurruntAttendance }) => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [showNextModal, setShowNextModal] = useState(false);
  const [nextModalContent, setNextModalContent] = useState("");
  const [selectedTask, setSelectedTask] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const handleImageClick = (id) => {
    setSelectedImage(id);
  };


  const handleCloseModal = () => {
    resetState();
    onClose();
  };

  const handleNextClick = () => {
    setShowNextModal(true);
  };

  const handleTextareaChange = (event) => {
    setNextModalContent(event.target.value);
  };


  const handleSubmit = async () => {
    setIsSubmitting(true);
    try {
      let breakData = {
        BreakReason: Number(selectedTask),
        Comment: nextModalContent,
        BreakType: Number(selectedImage),
      };

      await breakIn(breakData);
      await fetchCurruntAttendance();

      const breakReasonName = getBreakReasonLabel(selectedTask);

      toast.success(`You ${breakReasonName} break has started!`, {
        containerId: 'toaster',
        position: "top-right",

        className: "dark:bg-[rgb(193,236,193)]  bg-green-800 text-base dark:text-gray-800 text-gray-800",
        icon: false,
        autoClose: 3000,
        closeOnClick: true,
        pauseOnHover: true,
        hideProgressBar: false,
        style: {
          borderBottom: "2px solid gray",
          padding: "2px 6px",
          fontSize: '1.4rem',
          minHeight: "60px"

        },
        progressStyle: {
          backgroundColor: "green",
        },
      });

      handleCloseModal();
    } catch (err) {
      toast.error("An error occurred while submitting the break.");

      console.error("Error during break-in:", err);
    }
  };

  const handleTaskClick = (task) => {
    setSelectedTask(task);
  };

  const handleBackClick = () => {
    setShowNextModal(false);
    resetState();
  };

  const resetState = () => {
    setSelectedImage(null);
    setShowNextModal(false);
    setNextModalContent("");
    setSelectedTask(null);
    setIsSubmitting(false);
  };

  if (!isOpen) return null;

  const breakItems = Object.keys(breaks).map((key) => ({
    id: breaks[key].id,
    label: key,
    src: breaks[key].src,
  }));

  const allReasons = Object.values(breaks).flatMap((breakType) =>
    breakType.reasons.map((reason) => ({
      id: reason.id,
      label: reason.label,
    }))
  );

  const getBreakReasonLabel = (breakReasonId) => {
    const foundReason = allReasons.find(
      (reason) => reason.id === breakReasonId
    );
    return foundReason ? foundReason.label : "Unknown"; // Fallback if not found
  };


  return (
    <div className="fixed top-0 left-0 w-full h-full flex items-center justify-center z-50">
      <div
        className={`absolute w-full h-full transition-opacity duration-300 ${
          isOpen ? "bg-black/60 backdrop-blur-sm" : ""
        }`}
        onClick={handleCloseModal}
      ></div>
      {selectedImage !== null && (
        <div className="fixed top-0 left-0 w-full h-full flex items-center justify-center z-50">
          <div className="relative bg-white/70 dark:bg-black/40 backdrop-blur-3xl border-2 border-blue-500/20 dark:border-blue-400/20 rounded-2xl shadow-[0_20px_70px_-25px_rgba(0,0,0,0.6)] transform transition-all duration-300 scale-100 max-w-lg w-full mx-4 overflow-hidden">
            <div
              className="absolute -inset-[1px] bg-gradient-to-r from-blue-600/40 via-indigo-600/40 to-blue-600/40 rounded-2xl blur-sm opacity-50 pointer-events-none"
              aria-hidden="true"
            />
            <div className="relative">
            {/* Back Icon */}
            <div className="flex items-center w-full border-b border-blue-500/10 px-4 py-3">
              <button
                onClick={handleBackClick}
                className="text-gray-700 dark:text-gray-200 hover:bg-white/[0.06] dark:hover:bg-white/[0.08] p-1.5 rounded-full transition-colors duration-200"
                aria-label="Go back to previous step"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="1.5"
                  stroke="currentColor"
                  className="w-5 h-5"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18"
                  />
                </svg>
              </button>
              <h2 className="text-xl font-semibold text-gray-800 dark:text-white ml-2">
                {selectedImage === 1
                  ? "Official"
                  : selectedImage === 2
                  ? "Prayer"
                  : "Personal/Food"}
              </h2>
            </div>

            {/* Modal content */}
            <div className="p-4">
              {selectedImage === 1 && !showNextModal && (
                <div className="space-y-2">
                  {breaks.Official.reasons.map((reason) => (
                    <button
                      key={reason.id}
                      className={`w-full text-left p-3 rounded-lg transition-all duration-200 ${
                        selectedTask === reason.id
                          ? "bg-blue-500/15 border border-blue-400/25 text-blue-700 dark:text-blue-200"
                          : "bg-white/5 dark:bg-white/[0.04] border border-blue-500/10 hover:bg-white/[0.07] dark:hover:bg-white/[0.08] text-gray-700 dark:text-gray-300"
                      }`}
                      onClick={() => handleTaskClick(reason.id)}
                    >
                      {reason.label}
                    </button>
                  ))}
                </div>
              )}

              {selectedImage === 1 && showNextModal && (
                <div className="space-y-4">
                  <div className="bg-white/10 dark:bg-white/[0.04] border border-blue-500/10 p-3 rounded-xl">
                    <h3 className="text-sm font-medium text-gray-600 dark:text-gray-300">Selected Break</h3>
                    <p className="text-lg font-semibold text-gray-900 dark:text-white">
                      {getBreakReasonLabel(selectedTask)}
                    </p>
                  </div>
                  <textarea
                    className="w-full h-36 border border-blue-500/15 dark:border-blue-400/20 rounded-xl p-3 bg-white/10 dark:bg-black/20 text-gray-900 dark:text-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500/60 dark:focus:ring-blue-400/60 transition-all duration-200"
                    placeholder="Enter your comment here..."
                    onChange={handleTextareaChange}
                  />
                </div>
              )}

              {/* Prayer and Personal sections with similar styling */}
              {(selectedImage === 2 || selectedImage === 3) && (
                <div className="space-y-2">
                  {(selectedImage === 2 ? breaks.Prayer.reasons : breaks.Personal.reasons.filter(reason => reason.id !== 9))
                    .map((reason) => (
                      <button
                        key={reason.id}
                        className={`w-full text-left p-3 rounded-lg transition-all duration-200 ${
                          selectedTask === reason.id
                            ? "bg-blue-500/15 border border-blue-400/25 text-blue-700 dark:text-blue-200"
                            : "bg-white/5 dark:bg-white/[0.04] border border-blue-500/10 hover:bg-white/[0.07] dark:hover:bg-white/[0.08] text-gray-700 dark:text-gray-300"
                        }`}
                        onClick={() => handleTaskClick(reason.id)}
                      >
                        {reason.label}
                      </button>
                    ))}
                </div>
              )}
            </div>

            {/* Action buttons */}
            <div className="flex justify-end gap-3 p-4 border-t border-blue-500/10">
              <button
                className="px-6 py-2 rounded-xl bg-white/10 border border-blue-500/15 text-gray-900 dark:text-gray-100 hover:bg-white/[0.14] hover:border-blue-500/35 dark:bg-white/[0.04] dark:hover:bg-white/[0.08] transition-colors duration-200"
                onClick={handleCloseModal}
              >
                Close
              </button>
              {!showNextModal && selectedImage === 1 && (
                <button
                  className="px-6 py-2 rounded-xl bg-blue-500/15 border border-blue-400/30 text-blue-900 dark:text-blue-200 hover:bg-blue-500/25 hover:border-blue-400/40 transition-colors duration-200"
                  onClick={handleNextClick}
                >
                  Next
                </button>
              )}
              {(showNextModal || selectedImage === 2 || selectedImage === 3) && selectedTask && (
                <button
                  className={`px-6 py-2 rounded-xl bg-blue-500/15 border border-blue-400/30 text-blue-900 dark:text-blue-200 transition-colors duration-200 ${
                    isSubmitting || (selectedImage === 1 && !nextModalContent.trim()) ? "opacity-50 cursor-not-allowed" : "hover:bg-blue-600"
                  }`}
                  onClick={isSubmitting ? null : handleSubmit}
                  disabled={isSubmitting || (selectedImage === 1 && !nextModalContent.trim())}
                >
                  {isSubmitting ? "Submitting..." : "Submit"}
                </button>
              )}
            </div>
            </div>
          </div>
        </div>
      )}

      {/* Image selection section */}
      <div
        className={`relative bg-white/70 dark:bg-black/40 backdrop-blur-3xl border-2 border-blue-500/20 dark:border-blue-400/20 rounded-2xl shadow-[0_20px_70px_-25px_rgba(0,0,0,0.6)] p-8 z-50 transform transition-all duration-300 ${
          selectedImage === null ? "scale-100" : "scale-0"
        }`}
      >
        <div
          className="absolute -inset-[1px] bg-gradient-to-r from-blue-600/40 via-indigo-600/40 to-blue-600/40 rounded-2xl blur-sm opacity-50 pointer-events-none"
          aria-hidden="true"
        />
        <div className="relative">
        <div className="grid grid-cols-3 gap-8">
          {breakItems.map((item) => (
            <div
              key={item.id}
              className="flex flex-col items-center cursor-pointer group"
              onClick={() => handleImageClick(item.id)}
            >
              <div
                className={`w-28 h-28 rounded-xl p-3 transition-all duration-300 ${
                  selectedImage === item.id
                    ? "ring-4 ring-blue-500 shadow-lg shadow-blue-500/20"
                    : "group-hover:ring-2 group-hover:ring-blue-300 group-hover:shadow-lg"
                }`}
              >
                <img
                  src={item.src}
                  className="w-full h-full object-contain rounded-lg"
                  alt={item.label}
                />
              </div>
              <p className="mt-3 text-center font-medium text-gray-900 dark:text-gray-100 group-hover:text-blue-300 transition-colors duration-200 text-lg">
                {item.label}
              </p>
            </div>
          ))}
        </div>
        </div>
      </div>
    </div>
  );
};

export default BreakModal;
